export const SHORT_PLAIN_TEXT_64_LENGTH = 64;
export const SHORT_PLAIN_TEXT_150_LENGTH = 150;
export const SHORT_PLAIN_TEXT_200_LENGTH = 200;
export const SHORT_PLAIN_TEXT_LENGTH = 255;
export const MEDIUM_PLAIN_TEXT_LENGTH = 2048;
export const LONG_PLAIN_TEXT_LENGTH = 4096;
export const SHORT_RICH_TEXT_LENGTH = 16384;
export const LONG_RICH_TEXT_LENGTH = 65535;
export const ONE = 1;
export const ATTENDEES_PER_PAGE = 20;
export const ZERO = 0;
export const TWO = 2;
export const NOTIFICATION_INTERVAL = 10000;
export const MAXIMUM_BADGE_NOTIFICATIONS_NUMBER = 99;

export const EMAIL_VALIDATION_ERROR_MESSAGE = 'Must be a valid email address';
export const REQUIRED_ERROR_MESSAGE = ' is required';
export const SHORT_PLAIN_TEXT_VALIDATION_MESSAGE = `Too long - max length is ${SHORT_PLAIN_TEXT_LENGTH} characters`;
export const MEDIUM_PLAIN_TEXT_VALIDATION_MESSAGE = `Too long - max length is ${MEDIUM_PLAIN_TEXT_LENGTH} characters`;
export const DEFAULT_CSV_FILE_NAME = 'download.csv';
export const UNKNOWN_EMAIL = 'unknown_email';
export const PRESENTER_TITLE = 'KV Presenter';

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

export interface ISortingParams {
    name: string;
    direction: SortDirection;
}

export interface IReuqestFiltersParams {
    page: number;
    query: string;
    size: number;
    sort: ISortingParams;
}

export interface IPodiumFeatures {
    name: string;
    title: string;
    path: string;
}

export class PodiumFeatures {
  static readonly PRESENTER: IPodiumFeatures = {
    name: 'presenter',
    title: 'Presenter',
    path: '/presenter'
  };

  static readonly ATTENDEES: IPodiumFeatures = {
    name: 'attendees',
    title: 'Attendees',
    path: '/attendees'
  };

  static readonly QANDA: IPodiumFeatures = {
    name: 'qanda',
    title: 'Q&A',
    path: '/qanda'
  };

  static readonly POLLS: IPodiumFeatures = {
    name: 'polls',
    title: 'Polls',
    path: '/polls'
  };

  static readonly BLANK: IPodiumFeatures = {
    name: 'blank',
    title: 'Blank',
    path: '/blank'
  };
}

export enum NonceCSP {
  DND = 'PodiumDNDStyles'
}
